import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName', 'CustCode', 'customer_group', 'contact', 'SalesCode', 'collector','koran','iklan','npwp', 'bill2group', 'advertiser'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/customer${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    lookup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get('/customer');
                const {
                    list
                } = data;
                list.forEach(item => {
                    item.selected = false;
                });
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post('/customer', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/customer/${obj.customer_id}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/customer/detail/${obj.customer_id}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    group() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/customer/group`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    taxgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/customer/taxgroup`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName', 'CustCode', 'customer_group', 'contact', 'SalesCode', 'collector', 'koran', 'iklan', 'advertiser'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/customer/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'customer_list.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
}    
};